import React from "react";
import styled, { keyframes } from "styled-components";
import { green } from "./settings/colors";

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const LoadingRoot = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-shrink: 0;
`;

const Spinner = styled.div`
  box-sizing: border-box;
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  flex-shrink: 0;
  aspect-ratio: 1;
  border: 4px solid ${green[100]};
  border-top-color: ${green[300]};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const AppLoading = ({ size = 56, height, margin = "10px auto" }) => {
  const spinnerSize = height ?? size;

  return (
    <LoadingRoot style={{ margin }}>
      <Spinner $size={spinnerSize} role="status" aria-label="Loading" />
    </LoadingRoot>
  );
};

export default AppLoading;
